<template>
  <section class="full-height d-flex align-center pa-2">
    <payment-btn
      v-if="isMobil"
      name="mobil"
      class="btn-home"
      :title="$t('button.shortcut_scan_mobil')"
      logo="mobil"
      two-lines
      @click="toMobil"
    />
    <payment-btn
      v-if="isGiftOnly"
      name="cheque"
      class="btn-home"
      :title="$t('button.shortcut_scan_gift')"
      logo="giftchq"
      two-lines
      @click="toGift"
    />

    <app-footer />
  </section>
</template>

<script>
import AppFooter from '../core/Footer'
import { ActionEnum } from '@/modules/Enums'

export default {
  name: 'Shortcut',

  components: {
    AppFooter
  },

  props: {
    isGiftOnly: { type: Boolean, default: false },
    isMobil: { type: Boolean, default: false }
  },

  methods: {
    toGift () {
      this.$emit('title', this.$i18n.t('title.gift_scan'))
      this.$router.replace({
        name: 'action-choice',
        params: { action: ActionEnum.gift, mode: 'P', backToHome: true }
      })
    },
    toMobil () {
      this.$emit('title', this.$i18n.t('title.mobil_scan'))
      this.$router.replace({
        name: 'scan-nfc',
        params: { action: ActionEnum.mobil, mode: 'P', backToHome: true }
      })
    }
  }
}
</script>
